"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import styles from '../index.module.css'
import {Image, UnstyledButton, Text} from "@mantine/core";
import {loadResearcherList} from "@/service";
import {IResearcherDTO} from "@/form/researcher";
import {useMediaQuery} from "@mantine/hooks";

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize } = useGlobalStateStore();
    const [researcherData, setResearcherData] = useState<{[key: string]: IResearcherDTO[]}>({});

    useEffect(() => {
        loadResearcherList().then(data => {
            setResearcherData(data);
        })
    }, []);

    const [tab, setTab] = useState<string>("B");
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }
    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name="關於科政中心 - 合聘研究員"/>
                    )
                }
                <div
                    className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] text-[#5b5b5b] text-[35px] font-bold">
                        合聘研究員
                    </div>


                    <div className={cx(!mediaQueryLessSM && 'pt-10')}>
                        <div className="flex justify-end gap-1 border-b border-[#79b7b4]">
                            {/*<UnstyledButton onClick={() => setTab("A")}>*/}
                            {/*    <div*/}
                            {/*        className={cx(tab === "A" ? styles.bookmarkBG1Active : styles.bookmarkBG1,*/}
                            {/*            "text-white py-[15px] px-[25px] font-bold", loadCurrentFontSize(14, 18, 20))}>*/}
                            {/*        資深顧問*/}
                            {/*    </div>*/}
                            {/*</UnstyledButton>*/}
                            <UnstyledButton onClick={() => setTab("B")}>
                                <div
                                    className={cx(tab === "B" ? styles.bookmarkBG1Active : styles.bookmarkBG1,
                                        "text-white py-[15px] px-[25px] font-bold", loadCurrentFontSize(14, 18, 20))}>
                                    合聘研究員
                                </div>
                            </UnstyledButton>
                        </div>
                    </div>
                    <div className="mt-[35px]">


                        {
                            (Object.keys(researcherData).indexOf(tab) == -1) && (
                                <Text size="xl" c="dimmed">無目關資料</Text>
                            )
                        }

                        {
                            Object.keys(researcherData).map((key, i) => (
                                <div key={`r-container-${key}`}
                                     className={cx(tab === key ? "block" : "hidden", "flex flex-wrap gap-[30px]")}>

                                    {
                                        researcherData[key].map((item) => (
                                            <UnstyledButton key={`r-${item.resId}`}
                                                            component="a" target="_self"
                                                            href={`/consultant/${item.resId}`}
                                                            className="w-[200px] flex flex-col items-center gap-[15px]">

                                                <Image
                                                    src={`${process.env.NEXT_PUBLIC_API_HOST}/image/crop/${item.photoArhId?.arhId}`}
                                                    className="border border-[#ccc]"
                                                    radius={150}/>

                                                <div className="text-[30px] font-bold">{item.name}</div>
                                            </UnstyledButton>
                                        ))
                                    }

                                </div>
                            ))
                        }
                    </div>

                </div>
            </div>
            <Footer/>
        </div>
    );
}
